import { makeStyles, Typography } from "@material-ui/core";
import { LightenDarkenColor } from "lighten-darken-color";

const useStyles = makeStyles((theme) => ({
  iconCard: {
    margin: theme.spacing(1.5),
    minWidth: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    padding: theme.spacing(2.5),
    marginBottom: theme.spacing(0.5),
    fontSize: theme.spacing(10),
    borderRadius: "50%",
    boxShadow: "0px 3px 25px rgba(125, 125, 125, 0.5)",
  },
}));

function Badge(props) {
  const classes = useStyles();
  const Icon = props.icon;
  return (
    <div className={classes.iconCard}>
      <Icon
        className={classes.icon}
        style={
          props.achieved
            ? {
                background: `linear-gradient(to bottom, ${LightenDarkenColor(props.color, 100)}, ${
                  props.color
                }`,
                color: "#FFFFFF",
              }
            : { color: "rgba(125, 125, 125, 0.4)" }
        }
      />
      <Typography variant="subtitle2" component="h3" align="center" noWrap>
        {props.badgeAmount} {props.badgeUnit}
      </Typography>
      <Typography variant="caption">{props.badgeType}</Typography>
    </div>
  );
}

export default Badge;
